import { render, staticRenderFns } from "./characteristicsList.vue?vue&type=template&id=60d5e3d4&scoped=true"
import script from "./characteristicsList.vue?vue&type=script&lang=js"
export * from "./characteristicsList.vue?vue&type=script&lang=js"
import style0 from "./characteristicsList.vue?vue&type=style&index=0&id=60d5e3d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5e3d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d5e3d4')) {
      api.createRecord('60d5e3d4', component.options)
    } else {
      api.reload('60d5e3d4', component.options)
    }
    module.hot.accept("./characteristicsList.vue?vue&type=template&id=60d5e3d4&scoped=true", function () {
      api.rerender('60d5e3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/characteristicsList.vue"
export default component.exports